import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ActionBtn.module.scss";
import SonicLink from "../routing/SonicLink";

type Props = {
  label: string;
  icon?: IconProp;
  link?: string;
  colorReversal?: boolean;
  isDelete?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: () => void;
};

const ActionBtn: React.FC<Props> = ({
  label,
  icon,
  link,
  colorReversal = false,
  isDelete,
  type = "button",
  onClick,
}) => {
  const genClassName = () => {
    if (link) return `${styles["c-actionBtn"]} ${styles["link"]}`;
    if (colorReversal) return `${styles["c-actionBtn"]} ${styles["reversal"]}`;
    if (isDelete) return `${styles["c-actionBtn"]} ${styles["delete"]}`;
    return styles["c-actionBtn"];
  };

  return (
    <button
      className={genClassName()}
      onClick={onClick ?? undefined}
      type={type}
    >
      {link ? (
        <SonicLink to={link}>
          {icon ? <FontAwesomeIcon icon={icon} /> : null}
          {label}
        </SonicLink>
      ) : (
        <div className={styles["c-actionBtn__child"]}>
          {icon ? <FontAwesomeIcon icon={icon} /> : null}
          {label}
        </div>
      )}
    </button>
  );
};

export default ActionBtn;
